import { action } from 'satcheljs';

export const preloadTaskPanelData = action('PRE_LOAD_TODO_PANEL_DATA');
